import { FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E } from "../../../fable_modules/Fable.React.9.4.0/./Fable.React.FunctionComponent.fs.js";
import { value } from "../../../fable_modules/fable-library-js.4.19.0/Option.js";
import { int32ToString } from "../../../fable_modules/fable-library-js.4.19.0/Util.js";
import { reactApi } from "../../../fable_modules/Feliz.2.9.0/./Interop.fs.js";
import { View } from "./MeineLetzteSendung.fs.js";
import * as react from "react";
import { View as View_1 } from "./AnstehendeZahlung.fs.js";
import { View as View_2 } from "./LetzterBelegeingang.fs.js";
import { quickfinderBoxDashboard } from "../QuickFinder/View.fs.js";
import { View as View_3 } from "./MeineZahlen.fs.js";
import { Props, View as View_4 } from "./DigitaleKundenrechnung.fs.js";
import { View as View_5 } from "./NeusteDokumente.fs.js";
import { View as View_6 } from "./DokumentenDepot.fs.js";
import { View as View_7 } from "./News.fs.js";
import { Msg } from "./Types.fs.js";
import { DashboardProps } from "./Shared.fs.js";
import { empty, singleton, append, delay } from "../../../fable_modules/fable-library-js.4.19.0/Seq.js";
import { view as view_1 } from "./VertragsBestaetigung.fs.js";
import { Bannerlist } from "./Banner.fs.js";

const dashboardGrid = FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E((((value("C:\\BuildAgent\\work\\c238671ccc1e7da2\\BfsKundenportal\\src\\Bfs.Web.Kundenportal\\WebParts\\User\\Dashboard\\View.fs") + "#L") + int32ToString(value(13))) + ";") + "Dashboard.Shared.DashboardProps", "DashboardGrid", (props) => {
    let children_18, children, children_2, children_4, children_6, children_8, children_10, children_12, children_14, children_16;
    const patternInput = reactApi.useState(false);
    const showDigitaleKundenrechnung = patternInput[0];
    const gridClass = showDigitaleKundenrechnung ? "dashboard-grid" : "dashboard-grid ohne-digitale-kundenrechnung";
    const digitaleKundenrechnungClass = showDigitaleKundenrechnung ? "digitale-kundenrechnung-grid" : "digitale-kundenrechnung-grid is-hidden";
    const children_20 = [(children_18 = [(children = [View(props)], react.createElement("div", {
        className: "letzte-sendung-grid",
    }, ...children)), (children_2 = [View_1(props)], react.createElement("div", {
        className: "anstehende-zahlung-grid",
    }, ...children_2)), (children_4 = [View_2(props)], react.createElement("div", {
        className: "letzter-belegeingang-grid",
    }, ...children_4)), (children_6 = [quickfinderBoxDashboard(props.NavigateTo, props.GlobalDispatch, "")], react.createElement("div", {
        className: "quickfinder-grid",
    }, ...children_6)), (children_8 = [View_3(props)], react.createElement("div", {
        className: "meine-zahlen-grid",
    }, ...children_8)), (children_10 = [View_4(new Props(props, patternInput[1]))], react.createElement("div", {
        className: digitaleKundenrechnungClass,
    }, ...children_10)), (children_12 = [View_5(props)], react.createElement("div", {
        className: "neuste-dokumente-grid",
    }, ...children_12)), (children_14 = [View_6(props)], react.createElement("div", {
        className: "dokumenten-depot-grid",
    }, ...children_14)), (children_16 = [View_7(props)], react.createElement("div", {
        className: "news-grid",
    }, ...children_16))], react.createElement("div", {
        className: gridClass,
    }, ...children_18))];
    return react.createElement("div", {
        className: "dashboard",
    }, ...children_20);
}, undefined, undefined, "Of");

export function view(model, dispatch, navigateTo) {
    const dashboardProps = new DashboardProps((arg) => {
        dispatch(new Msg(1, [arg]));
    }, navigateTo, model.MostRecentCallback);
    return Array.from(delay(() => append((model.UserName.length > 0) ? singleton(react.createElement("h1", {
        className: "is-size-2 pb-6 pt-6",
    }, `Hallo, ${model.UserName}!`)) : empty(), delay(() => append(singleton(view_1([dashboardProps, model.UserName, model.UserSession])), delay(() => append(singleton(Bannerlist([dashboardProps.GlobalDispatch, dashboardProps.NavigateTo, model.UserSession])), delay(() => singleton(dashboardGrid(dashboardProps))))))))));
}

//# sourceMappingURL=View.fs.js.map
